/** 학습내용 templates/rows 스코프 신선도 시그니처: `count:max(updated_at)` */

export function buildLearningContentScopeVersion(
  rows: ReadonlyArray<{ updated_at?: string | null }>
): string {
  if (!rows.length) return '0:';
  let max = '';
  for (const row of rows) {
    const u = (row.updated_at ?? '').trim();
    if (u > max) max = u;
  }
  return `${rows.length}:${max}`;
}

export function learningContentScopeVersionFromHead(
  count: number | null | undefined,
  maxUpdatedAt: string | null | undefined
): string {
  const n = typeof count === 'number' && Number.isFinite(count) ? Math.max(0, Math.floor(count)) : 0;
  if (n <= 0) return '0:';
  return `${n}:${(maxUpdatedAt ?? '').trim()}`;
}
